import { render, staticRenderFns } from "./c-Materi.vue?vue&type=template&id=b10ed268&scoped=true&"
import script from "./c-Materi.vue?vue&type=script&lang=js&"
export * from "./c-Materi.vue?vue&type=script&lang=js&"
import style0 from "./c-Materi.vue?vue&type=style&index=0&id=b10ed268&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b10ed268",
  null
  
)

export default component.exports